export type StatusFilter = 'active' | 'inactive' | 'all'

export function matchesStatus(active: boolean, filter: StatusFilter): boolean {
  return filter === 'all' || active === (filter === 'active')
}
